import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Autocomplete as CoreAutocomplete } from '../../autocomplete/Autocomplete';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { DATA_FORM_INPUT } from '../../common/data';

export type AutocompleteProps = VFFieldProps<
  React.ComponentProps<typeof CoreAutocomplete>
>;
export const Autocomplete = React.forwardRef<
  HTMLInputElement,
  AutocompleteProps
>(
  (
    {
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      onChange: customOnChange,
      onBlur: customOnBlur,
      required,
      disabled,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<string>) => {
            const handleChange = React.useCallback(
              (value: any) => {
                const rv = { target: { name, value } };
                customOnChange ? customOnChange(rv) : onChange?.(rv);
              },
              [customOnChange, onChange, name]
            );
            const handleBlur = React.useCallback(
              (value: any) => {
                onBlur({
                  target: { name, value },
                } as any as React.FocusEvent<HTMLElement>);
                customOnBlur && customOnBlur({ target: { name, value } });
              },
              [customOnBlur, onBlur, name]
            );
            return (
              <CoreAutocomplete
                {...DATA_FORM_INPUT(name)}
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                {...other}
                disabled={disabled || meta.submitting}
                // @ts-ignore
                onChange={handleChange}
                // @ts-ignore
                onBlur={handleBlur}
                // @ts-ignore
                value={value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
